
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 291.023 291.023"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M233.515 102.634l28.914-40.896c7.816-11.047 13.919-25.863 13.63-33.091-.294-7.234-6.402-13.326-13.658-13.63-7.25-.294-22.083 5.803-33.129 13.619L188.371 57.56 74.172 3.006C61.967-2.824 45.911.194 38.318 9.767s-5.26 24.275 5.211 32.852l91.289 74.776-68.249 75.614-32.194-9.72c-12.95-3.922-27.456-3.323-32.384 1.316-4.933 4.645-.381 15.278 10.166 23.758l29.213 23.486s-1.099 5.107-2.464 11.411c-1.36 6.298 2.633 10.28 8.926 8.887l11.389-2.529 23.47 29.202c8.485 10.546 19.124 15.104 23.769 10.182 4.64-4.922 5.238-19.412 1.316-32.368L98.05 224.43l75.603-68.249 74.787 91.295c8.572 10.47 23.279 12.804 32.852 5.205 9.567-7.593 12.597-23.654 6.761-35.865l-54.538-114.182z","fill":"#010002"}})])
          )
        }
      }
    